import { createApp } from 'vue';
import http from './plugins/http';
import ProductsList from '../components/products/ProductsList.vue';

document.addEventListener( 'DOMContentLoaded', () => {
    const el = document.getElementById( 'productsApp' );
    if( ! el ) return;

    const app = createApp( ProductsList, {
        initialSearch: window.initialSearch || '',
        initialTag:    window.initialTag    || '',
        initialSort:   window.initialSort   || 'newest',
    });
    app.use( http );
    app.mount( el );
});